import React, { useState, useEffect, useRef } from "react";
import "./KenoGame.css";
import { api, socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";

const KenoLeftSidebar = ({ balance, gameId, drawnNumbers }) => {
  const [activeTab, setActiveTab] = useState("game");
  const [myHistory, setMyHistory] = useState([]);
  const [allBets, setAllBets] = useState([]);
  const [totalPlayers, setTotalPlayers] = useState(0);

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const userId = userInfo?.id;
  const phone = userInfo?.phone;

  useEffect(() => {
    if (userId) {
      socket.emit("joinGame", {
        userId,
        phone,
      });
    }
    // =========================================
    // JOINED
    // =========================================
    socket.on("joined", (data) => {
      // =====================================
      // CURRENT ROUND
      // =====================================

      if (data.playerStats) {
        setTotalPlayers(Number(data.playerStats.totalPlayers || 0));
      }
      if (data.allBets) {
        setAllBets(data.allBets);
      }

      if (data.myHistory) {
        setMyHistory(data.myHistory);
      }
    });

    // =========================================
    // PLAYERS UPDATE
    // =========================================
    socket.on("playersUpdate", (data) => {
      setTotalPlayers(Number(data.totalPlayers || 0));
    });

    // =========================================
    // PLAYER BET EVENT
    // =========================================
    socket.on("playerBet", (data) => {});

    // =========================================
    // LIVE GAME BETS
    // =========================================
    socket.on("liveGameBets", (data) => {
      setAllBets(data || []);
    });

    // =========================================
    // MY HISTORY
    // =========================================
    socket.on("myHistoryUpdate", (data) => {
      setMyHistory(data || []);
    });

    //=======================================
    // BETS UPDATED
    // =========================================
    socket.on("betsUpdated", (data) => {});
    // =========================================
    // CLEANUP
    // =========================================
    return () => {
      socket.off("joined");

      socket.off("playerBet");

      socket.off("betsUpdated");

      socket.off("liveGameBets");

      socket.off("myHistoryUpdate");

      socket.off("playersUpdate");
      socket.off("connect");

      socket.off("disconnect");
    };
  }, []);

  const myBets = allBets.filter((bet) => Number(bet.userId) === Number(userId));
  return (
    <div className="content_left_side for_desktop_only">
      <div className="side_cont_path">
        <div className="left_side_top">
          <div className="header_left">
            <span className="header_credit" id="my_credit">
              {balance} <span>ETB</span>
            </span>
          </div>

          <div className="game_id_contener">
            <div className="game_id">
              ID: <span className="game_id_num">{gameId}</span>
            </div>
          </div>
        </div>

        <div className="tab_content_wrapper">
          {/* TABS */}
          <div className="tabs left_side_tabs_top">
            <div
              className={`tab_itm ${activeTab === "game" ? "active" : ""}`}
              id="tab1"
              onClick={() => setActiveTab("game")}
            >
              GAME
            </div>
            <div
              className={`tab_itm ${activeTab === "history" ? "active" : ""}`}
              id="tab2"
              onClick={() => setActiveTab("history")}
            >
              HISTORY
            </div>
          </div>

          <div className="tab_conts left_side_tabs_cont">
            {/* GAME TAB */}
            <div
              className={`tab_cont cont_tab1 ${
                activeTab === "game" ? "active" : ""
              }`}
            >
              <div className="table_header">
                <div className="table_header_itm active">
                  <span id="trs_bets">All</span>{" "}
                  <span className="total_tickets_count">{totalPlayers}</span>
                </div>

                <div className="table_header_itm">
                  <span id="trs_mytiks">My Tickets</span>{" "}
                  <span className="my_tickets_count">
                    {allBets.filter((bet) => bet.userId === userId).length}
                  </span>
                </div>

                <div className="table_header_itm">
                  <span id="trs_mybets">My Bets</span>{" "}
                  <span className="my_bets_count">
                    {allBets.filter((bet) => bet.userId === userId).length}
                  </span>
                </div>
              </div>

              <div className="table_cont game_table">
                {allBets
                  .filter((bet) => bet.userId === userId)
                  .map((bet, index) => {
                    let nums = bet.numbers || [];

                    if (typeof nums === "string") {
                      try {
                        nums = JSON.parse(nums);
                      } catch {
                        nums = [];
                      }
                    }

                    return (
                      <div className="table_row other_tcket_itm" key={index}>
                        <div className="table_row_ttl">
                          {bet.user?.username || "Player"}
                        </div>

                        <div className="table_row_bet_nums">
                          {[...Array(10)].map((_, i) => {
                            const num = nums[i];

                            const isMatched = drawnNumbers.includes(
                              Number(num),
                            );

                            return (
                              <div
                                key={i}
                                className={`bet_nms ${!num ? "inactive" : isMatched ? "sell" : ""}`}
                              >
                                {num || ""}
                              </div>
                            );
                          })}
                        </div>

                        <div className="table_row_bet_status">
                          <div className="table_row_halff">
                            Bet {bet.betAmount}
                          </div>

                          <div className="table_row_halff game_status_wait">
                            Waiting
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* HISTORY TAB */}
            <div
              className={`tab_cont cont_tab2 ${
                activeTab === "history" ? "active" : ""
              }`}
            >
              <div className="table_cont game_mybet_history_path">
                <div className="game_mybet_history">
                  {myHistory
                    .filter((bet) => bet.userId === userId)
                    .map((bet, index) => {
                      let nums = bet.numbers || [];

                      if (typeof nums === "string") {
                        try {
                          nums = JSON.parse(nums);
                        } catch {
                          nums = [];
                        }
                      }
                      let matchedNumbers = bet.matchedNumbers || [];

                      if (typeof matchedNumbers === "string") {
                        try {
                          matchedNumbers = JSON.parse(matchedNumbers);
                        } catch {
                          matchedNumbers = [];
                        }
                      }
                      const filledNumbers = [...nums];

                      while (filledNumbers.length < 10) {
                        filledNumbers.push(null);
                      }

                      return (
                        <div className="tab_history_itm" key={index}>
                          <div className="tab_history_itm_top">
                            <div className="tab_history_itm_top_ttl">
                              <div className="tab_history_itm_top_ttl_line"></div>

                              <div className="tab_history_itm_top_ttl_dat">
                                <div className="tab_history_itm_top_ttl_dat_wrap">
                                  Draw ID:&nbsp;
                                  {bet.roundId}
                                  <span>
                                    &nbsp;
                                    {new Date(bet.createdAt).toLocaleString()}
                                  </span>
                                </div>
                              </div>

                              <div className="tab_history_itm_top_ttl_line"></div>
                            </div>
                          </div>

                          <div className="table_cont">
                            <div
                              className={`table_row ${
                                bet.status === "win" || bet.status === "won"
                                  ? "winrow"
                                  : ""
                              }`}
                            >
                              <div className="table_row_bet_nums">
                                {filledNumbers.map((num, i) => (
                                  <div
                                    key={i}
                                    className={`bet_nms ${
                                      !num
                                        ? "inactive"
                                        : matchedNumbers.includes(Number(num))
                                          ? "sell"
                                          : ""
                                    }`}
                                  >
                                    {num || ""}
                                  </div>
                                ))}
                              </div>

                              <div className="table_row_bet_status">
                                <div className="table_row_halff">
                                  Bet {Number(bet.betAmount).toFixed(2)}
                                </div>

                                {(bet.winAmount > 0 ||
                                  bet.status === "win" ||
                                  bet.status === "won") && (
                                  <div className="table_row_halff game_status_win">
                                    {bet.winAmount
                                      ? Number(bet.winAmount).toFixed(2)
                                      : "WIN"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KenoLeftSidebar;
